module.exports = __webpack_public_path__ + "img/home-hero.e450f150.jpg";